import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How do I get IP protection?",
    answer: `<p>In the majority of instances, safeguarding your intellectual property requires its registration for protective measures. Various intellectual property rights provide different levels of protection. As the owner of intellectual property, you can take measures to assert your legal rights against individuals who are violating your intellectual property</p>`,
  },
  {
    question: "What are the 4 main methods of protecting IP?",
    answer: ` <p>Copyrights, trademarks, patents, and trade secrets constitute the main categories of intellectual property protection. It can be challenging to decide on the most effective method for safeguarding intellectual property. Usually, it requires different methods considering the advanced fields such as industrial design or computer algorithms.</p>`,
  },
  {
    question: "What happens if IP is not protected?",
    answer: `<p>Initially, neglecting to secure your intellectual property can lead to missed business prospects. This is because competitors may readily replicate your concepts and offerings, presenting them as their original creations. Moreover, lack of protection leaves you without the ability to pursue legal recourse, even if you are aware that another company is violating your rights.</p>`,
  },
  {
    question: "How much does a patent cost?",
    answer: `<p>Typically, the fees for a patent attorney range from $8,000 to $10,000 for filing a patent application, although expenses can surpass this range. Generally, it is advisable to allocate a budget of approximately $15,000 to $20,000 to cover the entire patenting process for your innovative creation.</p>`,
  },
  {
    question: "What are the risks of IP protection?",
    answer: ` <p>Potential risks encompass the legal expenses and time involved in defending against a lawsuit related to intellectual property violation. If a legal setback occurs, it may lead to settlements or damages. Additionally, there is the risk of a reduction in revenues if the continuation of commercial activities becomes unstable</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>IP Protection Services FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
